import './index.css';

const RadioniceDodatnoEs = () => {
    return (
        <>
            <div className="row">
                <div className="col-md-12 col-td-12 col-12">
                    <h2>Kiel fari poziciigadon</h2>
                    <p>
                        La pozicigado povas esti agordita grupe aŭ individue.
                        <br /> Laborante en grupo, vi ricevas energian kaj emocian subtenon de aliaj partoprenantoj,
                        okazon partopreni aŭ simple observi la laboron de aliaj partoprenantoj, en kiuj vi povas akiri
                        potencajn kaj gravajn komprenojn.
                    </p>
                    <p>
                        Per individua laboro, vi ricevas pli trankvilan kaj pli intiman spacon por laboro. Por ĉiu, kiu
                        timas aŭ ne kapablas malfermiĝi al grupo, individua laboro estas bona elekto. La poziciigado
                        povas okazi en personaj renkontiĝoj aŭ rete.
                        <br /> Sendepende KIEL vi starigas la laboron, la plej grava afero por la sukceso de la laboro
                        estas KLARA INTERNA INTENCO kaj la volo akcepti ŝanĝon.
                    </p>
                    <p>
                        Kiel ajn la intenco formiĝis, malstreĉigu vian menson, malfermu vian koron, malfermu vin al tio,
                        kio povas veni. Nek tro, nek maltro venos - venos tio, kion vi bezonas, kiom vi bezonas kaj en
                        la formo en kiu vi bezonas.
                    </p>
                </div>
            </div>
        </>
    );
};

export default RadioniceDodatnoEs;
